<script>
import gsap from 'gsap'

export default {
    functional: true,
        props: {
        duration: {
            type: Number,
            default: .3
        },
    },
    render(createElement, context) {

        const transitionAttr = {
            props: {
            name: 'expand-height',
            mode: 'in-out',
            css: false,
        },
        on: {
        enter(ele, done) {
            const width = getComputedStyle(ele).width
            ele.style.transition = 'none'
            ele.style.position = 'absolute'
            ele.style.visibility = 'hidden'
            ele.style.height = 'inherit'
            ele.style.width = width

            const height = getComputedStyle(ele).height

            ele.style.position = 
            ele.style.visibility = 
            ele.style.width = ''
            ele.style.height = 0

            gsap.set(ele, {
                height: 0,
            })

            return gsap.to(ele, context.props.duration, {
                ease: 'expo.easeOut',
                height,
                onComplete() { 
                    ele.removeAttribute('style')
                    return done()
                }
            })
        },
        leave(ele, done) {
            const height = getComputedStyle(ele).height

            gsap.set(ele, {
                height,
            })

            return gsap.to(ele, context.props.duration, {
                height: 0,
                onComplete() {
                    ele.removeAttribute('style')
                    return done()
                }
            })
        },
        }
    }
    return createElement('transition', transitionAttr, context.children)
    }
}
</script>